module.exports = __webpack_public_path__ + "img/settings.17d7a372.svg";